{{#unless read_only}}
<i class="fa fa-times-circle-o fa-lg remove"></i>
{{/unless}}
